
import React, { Component } from "react";
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import WCMImage from './sfc/wcmimage'

export default class RestaurantCard extends Component {

  render() {

    let item = this.props.restaurant;
    let index = this.props.index;

    let guidesArray = [];
    if (item.Guide){
      guidesArray = item.Guide.split(",");
    }

    return (
      <div className={this.props.show === true ? "top-100-item show" : "top-100-item"}>
        <WCMImage WCMID={item.ImageID} />
        <div className="text-box">
          <h3>{item.Name}</h3>
          <div className="top-text">
            {item.Location &&
              <p className="restaurant-location"><em>{item.Location}</em></p>
            }
            {guidesArray.length > 0 &&
              <p className="guides-label"><strong>Guides:</strong>
                {guidesArray.map((item, index) => {
                  return <span key={"guide-top-list"+index}><Link to={"/"+item.toLowerCase().trim().replace(/\s/g, '-').replace(/['\&]/g, '')+this.props.linkExt}>&nbsp;{item}</Link></span>
                })}</p>
            }

            <p>{item.Text}</p>

            {item.Tip_One &&
              <p>{item.Tip_One}</p>
            }

            {item.Tip_Two &&
              <p>{item.Tip_Two}</p>
            }

            {item.What_To_Order &&
              <p className="to-order"><strong>What to Order: </strong>{item.What_To_Order}</p>
            }

            <p className="blurb-author">– {item.Author}</p>

            {item.Hours &&
              <p><strong>Hours: </strong>{item.Hours}</p>
            }
            {item.Phone_Number &&
              <p><strong>Phone: </strong>{item.Phone_Number}</p>
            }
            {item.Website &&
              <p><a target="_blank" href={item.Website}>{item.Name} website</a></p>
            }
          </div>

          <div className="bottom-text">
            <p className="tags">{item.Tags}</p>
            <p className={this.props.show === true ? "add active" : "add"} onClick={(e) => this.props.adjustList(e, index)}><FontAwesomeIcon icon={["far", "bookmark"]}/> {this.props.show === true ? "Remove" : "Add to list"}</p> 
          </div>
        </div>
      </div>

    )
  }
}
